<template>
  <div id="IntelligentDepositProducts">
    <div class="shadePiece" v-if="this.prodClass === 'FP102' || this.prodClass === 'FP104'"></div>
    <div class="GridA50E732F">
      <md-drop-menu :ref="'dropMenu'" :data="filterData" @change="dataChange"/>
    </div>
    <!--月供存款-->
    <div class="Grid50E0881F" v-if="this.prodClass === 'FP100'">
      <div class="productItem" v-for="(item,index) of proInfo" :key="item.prodType">
        <div class="GridF03E9C14">
          <p>
            <span :text="'0+0+0'" class="text3868F7DC">{{realRate[index]}}%</span>
          </p>
        </div>
        <div class="Grid90C5A234">
          <span :text="'月月高'" class="textB2BE211D">{{item.prodDesc}}</span>
<!--          <span :text="'存期M2(5+5+2)'" class="textFF5991CC">存期M2(5+5+2)</span>-->
        </div>
        <div class="Grid26E6D14C">
          <md-button
            :text="'查看更多'"
            :type="'primary'"
            :round="true"
            @click="toEntry(item)"
          >{{$t('label.label52')}}
          </md-button>
        </div>
      </div>
    </div>
    <!--活期-->
    <div class="Grid50E0881F" v-else-if="prodClass === 'FP101'">
      <div class="productItem" v-for="item of proInfo" :key="item.prodType">
        <div class="GridF03E9C14">
          <p>
            <span :text="'0+0+0'" class="text3868F7DC">{{item.intRate}}%</span>
          </p>
        </div>
        <div class="Grid90C5A234">
          <span :text="'月月高'" class="textB2BE211D">{{item.prodDesc}}</span>
          <!--          <span :text="'存期M2(5+5+2)'" class="textFF5991CC">存期M2(5+5+2)</span>-->
        </div>
        <div class="Grid26E6D14C">
          <md-button
            :text="'查看更多'"
            :type="'primary'"
            :round="true"
            @click="toEntry(item)"
          >{{$t('label.label52')}}
          </md-button>
        </div>
      </div>
    </div>
    <!--月月高-->
    <div class="Grid50E0881F" v-else-if="prodClass === 'FP102'">
      <div v-for="item of proInfo" :key="item.prodType">
        <div class="productItem" v-if="item.depositTerm.split(',').indexOf('M6')>-1&&item.intRate[0].split('+')[2]!==''">
          <div class="GridF03E9C14">
            <p>
              <span :text="'0+0+0'" class="text3868F7DC">{{item.intRate[0].split('+')[2]}}</span>
              <span :text="'0+0+0'" class="smallFont">{{$t('label.label159')}}</span>
            </p>
          </div>
          <div class="Grid90C5A234">
            <span :text="'月月高'" class="textB2BE211D">{{item.prodDesc}}</span>
            <span :text="'存期M2(5+5+2)'" class="textFF5991CC">{{$t('label.label51')}} {{$setDepositTerm('M6')}}(3+2+1)</span>
          </div>
          <div class="Grid26E6D14C">
            <md-button
              :text="'查看更多'"
              :type="'primary'"
              :round="true"
              @click="toEntry(item, 'M6')"
            >{{$t('label.label52')}}
            </md-button>
          </div>
        </div>
        <div class="productItem" v-if="item.depositTerm.split(',').indexOf('M12')>-1&&item.intRate[1].split('+')[2]!==''">
          <div class="GridF03E9C14">
            <p>
              <span :text="'0+0+0'" class="text3868F7DC">{{item.intRate[1].split('+')[2]}}</span>
              <span :text="'0+0+0'" class="smallFont">{{$t('label.label159')}}</span>
            </p>
          </div>
          <div class="Grid90C5A234">
            <span :text="'月月高'" class="textB2BE211D">{{item.prodDesc}}</span>
            <span :text="'存期M2(5+5+2)'" class="textFF5991CC">{{$t('label.label51')}} {{$setDepositTerm('M12')}}(5+5+2)</span>
          </div>
          <div class="Grid26E6D14C">
            <md-button
              :text="'查看更多'"
              :type="'primary'"
              :round="true"
              @click="toEntry(item, 'M12')"
            >{{$t('label.label52')}}
            </md-button>
          </div>
        </div>
      </div>
    </div>
    <!--天天利-->
    <div class="Grid50E0881F" v-else-if="prodClass === 'FP103'">
      <div v-for="item of proInfo" :key="item.prodType">
        <div class="productItem" v-if="item.depositTerm.split(',').indexOf('D160')>-1&&item.intRate[2].split('+')[2]">
          <div class="GridF03E9C14">
            <p>
              <span :text="'0+0+0'" class="text3868F7DC">{{item.intRate[2].split('+')[2]}}</span>
              <span :text="'0+0+0'" class="smallFont">{{$t('label.label159')}}</span>
            </p>
          </div>
          <div class="Grid90C5A234">
            <span :text="'月月高'" class="textB2BE211D">{{item.prodDesc}}</span>
            <span :text="'存期M2(5+5+2)'" class="textFF5991CC">{{item.cycleList[2].text}}{{item.prodDesc}}</span>
          </div>
          <div class="Grid26E6D14C">
            <md-button
              :text="'查看更多'"
              :type="'primary'"
              :round="true"
              @click="toEntry(item,'D160')"
            >{{$t('label.label52')}}
            </md-button>
          </div>
        </div>
        <div class="productItem" v-if="item.depositTerm.split(',').indexOf('D100')>-1&&item.intRate[1].split('+')[2]">
          <div class="GridF03E9C14">
            <p>
              <span :text="'0+0+0'" class="text3868F7DC">{{item.intRate[1].split('+')[2]}}</span>
              <span :text="'0+0+0'" class="smallFont">{{$t('label.label159')}}</span>
            </p>
          </div>
          <div class="Grid90C5A234">
            <span :text="'月月高'" class="textB2BE211D">{{item.prodDesc}}</span>
            <span :text="'存期M2(5+5+2)'" class="textFF5991CC">{{item.cycleList[1].text}}{{item.prodDesc}}</span>
          </div>
          <div class="Grid26E6D14C">
            <md-button
              :text="'查看更多'"
              :type="'primary'"
              :round="true"
              @click="toEntry(item,'D100')"
            >{{$t('label.label52')}}
            </md-button>
          </div>
        </div>
        <div class="productItem" v-if="item.depositTerm.split(',').indexOf('D80')>-1&&item.intRate[3].split('+')[2]">
          <div class="GridF03E9C14">
            <p>
              <span :text="'0+0+0'" class="text3868F7DC">{{item.intRate[3].split('+')[2]}}</span>
              <span :text="'0+0+0'" class="smallFont">{{$t('label.label159')}}</span>
            </p>
          </div>
          <div class="Grid90C5A234">
            <span :text="'月月高'" class="textB2BE211D">{{item.prodDesc}}</span>
            <span :text="'存期M2(5+5+2)'" class="textFF5991CC">{{item.cycleList[3].text}}{{item.prodDesc}}</span>
          </div>
          <div class="Grid26E6D14C">
            <md-button
              :text="'查看更多'"
              :type="'primary'"
              :round="true"
              @click="toEntry(item,'D80')"
            >{{$t('label.label52')}}
            </md-button>
          </div>
        </div>
        <div class="productItem" v-if="item.depositTerm.split(',').indexOf('D50')>-1&&item.intRate[0].split('+')[2]">
          <div class="GridF03E9C14">
            <p>
              <span :text="'0+0+0'" class="text3868F7DC">{{item.intRate[0].split('+')[2]}}</span>
              <span :text="'0+0+0'" class="smallFont">{{$t('label.label159')}}</span>
            </p>
          </div>
          <div class="Grid90C5A234">
            <span :text="'月月高'" class="textB2BE211D">{{item.prodDesc}}</span>
            <span :text="'存期M2(5+5+2)'" class="textFF5991CC">{{item.cycleList[0].text}}{{item.prodDesc}}</span>
          </div>
          <div class="Grid26E6D14C">
            <md-button
              :text="'查看更多'"
              :type="'primary'"
              :round="true"
              @click="toEntry(item,'D50')"
            >{{$t('label.label52')}}
            </md-button>
          </div>
        </div>
      </div>
    </div>
    <!--定期-->
    <div class="Grid50E0881F" v-else-if="prodClass === 'FP104'">
      <div v-for="item of proInfo" :key="item.prodType">
        <div class="productItem" v-if="item.cycResultList.filter(i => i.value === filterData[0].value).length > 0">
          <div class="GridF03E9C14">
            <p>
              <span :text="'0+0+0'" class="text3868F7DC">{{item.newRate}}%</span>
<!--              <span :text="'0+0+0'" class="text3868F7DC">{{filterData[0].value}}%</span>-->
            </p>
          </div>
          <div class="Grid90C5A234">
            <span :text="'月月高'" class="textB2BE211D">{{item.prodDesc}}</span>
          </div>
          <div class="Grid26E6D14C">
            <md-button
              :text="'查看更多'"
              :type="'primary'"
              :round="true"
              @click="toEntry(item)"
            >{{$t('label.label52')}}
            </md-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showNoData" class="nodata">
      <p >暂无数据</p>
    </div>
  </div>
</template>
<script>
import { Button, DropMenu } from '@gidc/mobile'
import { ACCONTINFOQUERY, CUSSOURSE, LOGINPRODLIST, PRODINFO } from '../../api/smartdeposit'
import { mapGetters } from 'vuex'
export default {
  name: 'IntelligentDepositProducts',
  components: {
    [Button.name]: Button,
    [DropMenu.name]: DropMenu
  },
  computed: {
    ...mapGetters([
      'RnInfo',
      'prodClass',
      'buyProInfo'
    ])
  },
  data () {
    return {
      filterData: [
        {
          text: '',
          value: '',
          options: [
            {
              value: 'MOP',
              text: 'MOP'
            },
            {
              value: 'HKD',
              text: 'HKD'
            }
          ]
        },
        {
          text: this.$t('label.label167'),
          value: '',
          options: [
          ]
        }
      ],
      getData: [],
      proInfo: [],
      realRate: [],
      terms: [],
      cycResultList: [], // 币种数组
      contResultList: [],
      isNewCus: false,
      proLists: [],
      showNoData: false
    }
  },
  methods: {
    getCycList () {
      let params = {}
      if (this.prodClass !== 'FP102' && this.prodClass !== 'FP103') {
        params = {
          prodClass: this.prodClass,
          ccy: 'MOP',
          tranAmt: '10000'
        }
      } else {
        params = {
          prodClass: this.prodClass,
          ccy: 'MOP',
          tranAmt: '10000',
          model: '1'
        }
      }
      this.$remote.post(PRODINFO + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          const ccyList = []
          const contList = []
          const cycResultList = []
          const contResultList = []
          let list = res.list
          if (this.prodClass === 'FP104') {
            console.log('this.isNewCus', this.isNewCus)
            list = list.filter(item => { return item.prodType === 'FP01060006' && this.isNewCus })
          }
          for (let i = 0; i < list.length; i++) {
            list[i].minStartAmt.split(',').forEach(item => {
              ccyList.push(item.split('|'))
            })
            list[i].minContriAmt.split(',').forEach(item => {
              contList.push(item.split('|'))
            })
          }
          ccyList.forEach(item => {
            if (item[0] !== 'C') {
              if (item[2] !== 'null') {
                cycResultList.push({ text: item[1], value: item[1] })
              }
            }
          })
          contList.forEach(item => {
            if (item[0] !== 'C') {
              contResultList.push({ text: item[1], value: item[1] })
            }
          })
          this.cycResultList = [...new Set(cycResultList)]
          this.contResultList = [...new Set(contResultList)]
          let result = this.cycResultList.filter(item => {
            return item.value === 'MOP' || item.value === 'HKD'
          })
          const obj = {}
          result = result.reduce((item, next) => {
            if (!obj[next.value]) {
              obj[next.value] = true
              item.push(next)
            }
            return item
          }, [])
          this.filterData[0].options = result
        })
    },
    // 查询产品列表
    getProList () {
      this.$remote.post(LOGINPRODLIST + '?_locale=' + this.$exchangeLang(this.RnInfo.language),
        {},
        { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          const arr = res.list
          // console.log('1111111111', arr)
          this.proLists = arr.map(item => { return item.prodClass })
          // console.log('22222222222', this.proLists)
          this.customerPermission()
        })
    },
    getList () {
      let a
      console.log(this.filterData[1].text)
      switch (this.filterData[1].text) {
        case this.$t('label.label161'): a = '10000'
          break
        case this.$t('label.label43'): a = '100000'
          break
        case this.$t('label.label44'): a = '1000000'
          break
        case this.$t('label.label45'): a = '20000'
          break
        case this.$t('label.label46'): a = '100000'
          break
        case this.$t('label.label47'): a = '200000'
          break
        case this.$t('label.label48'): a = '500000'
          break
        case this.$t('label.label49'): a = '500000'
          break
        case this.$t('label.label50'): a = '200000'
          break
      }
      let params
      if (this.prodClass !== 'FP100') {
        if (this.prodClass !== 'FP102' && this.prodClass !== 'FP103') {
          params = {
            prodClass: this.prodClass,
            ccy: this.filterData[0].value,
            tranAmt: a
          }
        } else {
          params = {
            prodClass: this.prodClass,
            ccy: this.filterData[0].value,
            tranAmt: a,
            model: '1'
          }
        }
      } else {
        params = {
          prodClass: this.prodClass,
          ccy: this.filterData[0].value,
          tranAmt: '100000'
        }
      }
      this.$remote.post(PRODINFO + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          let list = res.list
          // 筛选定期 全新用户
          if (this.prodClass === 'FP104') {
            list = list.filter(item => { return item.prodType === 'FP01060006' && this.isNewCus })
          }
          for (let i = 0; i < list.length; i++) {
            this.proInfo[i] = list[i]
            console.log('newcus', list[i])

            const cycleList = []
            const cycResultList = []
            const contResultList = []
            if (this.proInfo[i].depositTerm !== '' && this.proInfo[i].depositTerm !== undefined) {
              if (this.proInfo[i].prodClass !== 'FP100') {
                this.proInfo[i].depositTerm.split(',').forEach(item => {
                  cycleList.push({
                    text: this.$setDepositTerm(item),
                    value: item
                  })
                })
              } else if (this.proInfo[i].prodClass === 'FP100') {
                const t = this.proInfo[i].intRate.split(',')
                this.proInfo[i].depositTerm.split(',').forEach((item, index) => {
                  cycleList.push({
                    text: this.$setDepositTerm(item),
                    value: item,
                    rate: t[index]
                  })
                })
                console.log(cycleList)
                this.filterData[1].options = cycleList
                if (this.buyProInfo && this.buyProInfo.depositType) {
                  this.filterData[1].text = this.buyProInfo.depositType.text
                  this.filterData[1].value = this.buyProInfo.depositType.value
                } else {
                  this.filterData[1].text = this.filterData[1].options[0].text
                  this.filterData[1].value = this.filterData[1].options[0].value
                }
              }
            }
            if (this.proInfo[i].minStartAmt !== '' && this.proInfo[i].minStartAmt !== undefined) {
              const list = this.proInfo[i].minStartAmt.split(',')
              const ccyList = []
              list.forEach(item => {
                ccyList.push(item.split('|'))
              })
              ccyList.forEach(item => {
                if (item[0] !== 'C') {
                  if (item[2] !== 'null') {
                    cycResultList.push({ text: item[1], value: item[1], minValue: item[2] })
                  }
                }
              })
            }

            if (this.proInfo[i].minContriAmt !== '' && this.proInfo[i].minContriAmt !== undefined && this.proInfo[i].prodClass === 'FP100') {
              const list = this.proInfo[i].minContriAmt.split(',')
              const contList = []
              list.forEach(item => {
                contList.push(item.split('|'))
              })
              contList.forEach(item => {
                if (item[0] !== 'C') {
                  contResultList.push({ text: item[1], value: item[1], minValue: item[2] })
                }
              })
            }

            if (this.proInfo[i].prodClass !== 'FP102' && this.proInfo[i].prodClass !== 'FP103' && this.proInfo[i].prodClass !== 'FP100') {
              const rate = this.proInfo[i].intRate.split(',').reduce((num1, num2) => {
                return Number(num1) > Number(num2) ? num1 : num2
              })
              this.proInfo[i].newRate = rate
            } else {
              const rate = this.proInfo[i].intRate.split(',')
              this.proInfo[i].intRate = rate
            }
            this.proInfo[i].cycResultList = cycResultList.filter(item => {
              // return item.value === 'MOP' || item.value === 'HKD'
              return item.value === params.ccy
            })
            this.proInfo[i].cycleList = cycleList
            this.proInfo[i].contResultList = contResultList
            this.proInfo[i].isShow = true
            this.proInfo.splice(i, 1, this.proInfo[i])
            if (this.proInfo[i].prodClass === 'FP100') {
              for (const item of this.proInfo[i].cycleList) {
                if (this.filterData[1].value === item.value) {
                  this.realRate[i] = item.rate
                }
              }
            }
            console.log('end')
          }
          console.log('this.proInfo', this.proInfo)
        })
    },
    getMyPosition () {
      const params = {
        serviceCode: 'MBSD_BP_FP', // 服务领域MBSD_BP_FP
        messageType: '1400', // 服务类型
        messageCode: '0103', // 服务编码
        baseAcctNo: '', // 理财账户
        linkedBaseAcctNo: '', // 购买账户
        prodType: 'FP01060006', // 产品类型
        documentType: '', // 证件类型
        documentId: '', // 证件号码
        startDate: '', // 查询开始时间
        endDate: '' // 查询结束时间
      }
      this.$remote.post(ACCONTINFOQUERY + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.list.length > 0 || res.apiCode !== 'FP0116') {
            this.isNewCus = false
          }
          if (this.proLists.indexOf(this.prodClass) > -1) {
            this.getCycList()
            this.getList()
          } else {
            this.showNoData = true
            console.log('产品未开放')
          }
        })
    },
    customerPermission () {
      this.$remote.post(CUSSOURSE + '?_locale=' + this.$exchangeLang(this.RnInfo.language),
        {},
        { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.source && res.source === '5') {
            this.isNewCus = true
            this.getMyPosition()
          } else {
            this.isNewCus = false
            if (this.proLists.indexOf(this.prodClass) > -1) {
              this.getCycList()
              this.getList()
            } else {
              this.showNoData = true
              console.log('产品未开放')
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    dataChange (barItem, listItem) {
      if (barItem === this.filterData[0]) {
        this.filterData[0].text = listItem.text
        this.filterData[0].value = listItem.value
        console.log(this.filterData[0].text)
        this.getList()
      } else if (barItem === this.filterData[1] && this.prodClass !== 'FP100') {
        console.log(this.filterData[1].text)
        this.getList()
      } else {
        this.filterData[1].text = listItem.text
        this.filterData[1].value = listItem.value
        this.filterData[1].text = listItem.text
        for (let i = 0; i < this.proInfo.length; i++) {
          for (const item of this.proInfo[i].cycleList) {
            if (this.filterData[1].value === item.value) {
              this.realRate.splice(i, 1, item.rate)
            }
          }
        }
      }
    },
    getRates (ccy) {
      const params = {
        prodClass: this.prodClass,
        prodType: this.buyProInfo.prodType,
        ccy: ccy,
        tranAmt: '10000',
        model: '1'
      }
      this.$remote.post(PRODINFO + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          console.log(res.list[0])
          const t = res.list[0]
          let tableRates = []
          if (ccy === 'MOP') {
            const rates = t.intRate.split(',')
            tableRates = tableRates.concat(rates).concat(this.buyProInfo.intRate)
          } else {
            const rates = t.intRate.split(',')
            tableRates = tableRates.concat(this.buyProInfo.intRate).concat(rates)
          }
          this.$store.commit('buyProInfo', { ...this.buyProInfo, intRate: tableRates })
          this.$router.push('depositOfMonth')
        }
        )
    },
    setFilterData () {
      const type = this.prodClass
      let t
      if (type === 'FP102') {
        t = [
          {
            value: '0',
            text: this.$t('label.label42')
          },
          {
            value: '1',
            text: this.$t('label.label43')
          },
          {
            value: '2',
            text: this.$t('label.label44')
          }
        ]
      } else if (type === 'FP101') {
        t = [
          {
            value: '0',
            text: this.$t('label.label45')
          },
          {
            value: '1',
            text: this.$t('label.label46')
          },
          {
            value: '2',
            text: this.$t('label.label47')
          },
          {
            value: '3',
            text: this.$t('label.label48')
          }
        ]
      } else if (type === 'FP103') {
        t = [
          {
            value: '0',
            text: this.$t('label.label49')
          }
        ]
      } else if (type === 'FP104') {
        t = [
          {
            value: '0',
            text: this.$t('label.label45')
          }
        ]
      }
      if (this.buyProInfo && this.buyProInfo.ccy) {
        this.filterData[0].text = this.buyProInfo.ccy.text
        this.filterData[0].value = this.buyProInfo.ccy.value
      } else {
        if (this.prodClass === 'FP104') {
          console.log('1231313')
          const obj = this.filterData[0].options.find(item => item.value === 'HKD')
          this.filterData[0].text = obj ? obj.text : this.filterData[0].options[0].text
          this.filterData[0].value = obj ? obj.value : this.filterData[0].options[0].value
        } else {
          this.filterData[0].text = this.filterData[0].options[0].text
          this.filterData[0].value = this.filterData[0].options[0].value
        }
      }

      if (type !== 'FP100') {
        this.filterData[1].options = t
        this.filterData[1].text = this.filterData[1].options[this.filterData[1].options.length - 1].text
      } else {
        this.filterData[1].text = this.$t('label.label51')
      }
    },
    toEntry (item, depositType = '') {
      console.log(item)
      const type = this.prodClass
      if (this.prodClass === 'FP100') {
        depositType = this.filterData[1].value
      }
      this.$store.commit('buyProInfo', { ...item, ccy: { text: this.filterData[0].value, value: this.filterData[0].value }, depositType: { text: this.$setDepositTerm(depositType), value: depositType } })
      if (type === 'FP100') {
        this.$router.push('depositOfPerMonth')
      } else if (type === 'FP101') {
        this.$router.push('depositOfCurrent')
      } else if (type === 'FP102') {
        if (this.buyProInfo.ccy.value === 'MOP') {
          this.getRates('HKD')
        } else {
          this.getRates('MOP')
        }
      } else if (type === 'FP103') {
        this.$router.push('depositOfDay')
      } else if (type === 'FP104') {
        this.$router.push('depositOfRegular')
      }
    }
  },
  created () {
    this.setFilterData()
    this.getProList()
  }
}
</script>
<style lang="stylus">
  #IntelligentDepositProducts{
    .GridA50E732F{
      .md-drop-menu{
        position relative
        height .9rem
        .bar-item{
          font-size .28rem
          font-weight 400
          color #1E1E1E
          line-height .4rem
        }
        .md-drop-menu-list{
          padding-top 1.9rem
        }
      }
    }
    .Grid26E6D14C{
      .md-button{
        min-width 1.6rem
        height .6rem
      }
      .md-button.primary{
        background #EBF4FF
      }
      .md-button.primary::after{
        content none
      }
      .md-button-inner{
        overflow visible
        .md-button-content{
          color #0076FF
          font-size .28rem
          font-weight 500
          line-height .4rem
          height .4rem
        }
      }
    }
  }
</style>
<style lang="stylus" scoped>
  #IntelligentDepositProducts{
    position relative
    .shadePiece{
      position absolute
      background-color #FFF
      width 50vw
      height .9rem
      z-index 2000
      right 0
      top 0
    }
    .Grid50E0881F{
/*      margin-top 1.03rem*/
      .productItem{
        padding 0 .3rem
        display flex
        height 1.72rem
        position relative
        .GridF03E9C14{
          display flex
          flex-direction row
          width 27%
          justify-content flex-start
          align-items center
          p{
            height .42rem
            display flex
            align-items flex-end
            .text3868F7DC{
              display block
              font-size .42rem
              color #FF5B58
              height .42rem
              line-height .42rem
            }
            .smallFont{
              display block
              font-size .18rem
              color #FF5B58
              height .18rem
              line-height .18rem
              white-space nowrap
              vertical-align bottom
            }
          }
        }
        .Grid90C5A234{
          display flex
          flex-direction column
          width 48%
          justify-content center
          align-items stretch
          .textB2BE211D{
            font-size .32rem
            line-height .45rem
            color #333333
            font-weight 500
          }
          span+span{
            padding-top .09rem
          }
          .textFF5991CC{
            font-size .24rem
            color #666666
            height .33rem
            line-height .33rem
          }
        }
        .Grid26E6D14C{
          display:flex;
          width:25%;
          padding-right .2rem
          align-items:center;
          justify-content center
        }
      }
      .productItem:after{
        content ''
        width 90%
        height .02rem
        background-color rgb(242, 242, 242)
        position absolute
        bottom 0
        left 50%
        transform translateX(-50%)
      }
    }
    .nodata{
      font-size .28rem
      position relative
      width 100%
      height 70vh
      p{
        position: absolute
        left 50%
        top 50%
        transform translate(-50%, -50%)
      }
    }
  }
</style>
